import './index.scss'
$("header .nav a").eq(5).addClass("active")